module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_6005.dd3bac2c.png";